import { render } from "./paySuccess.vue?vue&type=template&id=706e3c1b&scoped=true"
import script from "./paySuccess.vue?vue&type=script&lang=js"
export * from "./paySuccess.vue?vue&type=script&lang=js"

import "./paySuccess.vue?vue&type=style&index=0&id=706e3c1b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-706e3c1b"

export default script